<template>
    <div id="dashboard-page" style="margin-bottom:55px;">
        <b-card>
            <b-row class="mb-0">
              <b-col md="8">
                <h3>{{$route.name}}</h3>
                <b-breadcrumb>
                  <b-breadcrumb-item><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item>
                  <b-breadcrumb-item><router-link to="/sales/sales-order">Sales Order</router-link></b-breadcrumb-item>
                  <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
              </b-col>
              <b-col md="4 text-right mt-4">
                <b-button v-b-tooltip.hover.top title="Reject" v-if="model.status === 'Requested'" variant="danger" class="btn-md mr-1 mt-0" @click="showModal('reject')">
                    <font-awesome-icon icon="times-circle"></font-awesome-icon>
                </b-button>
                <b-button v-b-tooltip.hover.top title="Approve" v-if="model.status === 'Requested'" variant="success" class="btn-md mr-1 mt-0" @click="showModalSales('approve')">
                    <font-awesome-icon icon="check-circle"></font-awesome-icon>
                </b-button>
                <b-button v-b-tooltip.hover.top title="Download to PDF" @click="doExportToPDF()" variant="info" class="btn-download float-right"><font-awesome-icon icon="download"/></b-button>
              </b-col>
            </b-row>
              <div class="border-bottom"></div>
              <b-form class="mt-3 mx-2">
                <b-row class="my-4">
                  <div class="icon-flag">
                  </div>
                  <b-col md="6 mt-2">
                    <b-button disabled pill variant="outline-primary" style="font-weight:bold!important;font-size:13px!important;margin-left:-15px!important;" :href="'#'">Company: {{model.company}}</b-button>
                    <b-button class="ml-2" disabled pill variant="outline-primary" style="font-weight:bold!important;font-size:13px!important;" :href="'#'">Branch: {{model.branch}}</b-button>
                  </b-col>
                </b-row>
                <b-row>
                    <b-col md="6">
                      <b-row>
                        <b-col md="4"><label class="labels">Sales Order ID</label></b-col>
                        <b-col md="8"><p>{{ model.orderId !== null ? model.orderId : '-' }}</p></b-col>
                      </b-row>
                      <b-row>
                        <b-col md="4"><label class="labels">Customer</label></b-col>
                        <b-col md="8"><p>{{ model.customer !== '' ? model.customer : '-' }}</p></b-col>
                      </b-row>
                      <b-row>
                        <b-col md="4"><label class="labels">Sales Person</label></b-col>
                        <b-col md="8"><p>{{ model.requestedBy !== null || model.requestedBy !== 'null' ? model.requestedBy : '-' }}</p></b-col>
                      </b-row>
                      <b-row>
                        <b-col md="4"><label class="labels">Status</label></b-col>
                        <b-col md="8"><p><b-badge :variant="getStatusColor(model.status)">{{model.status}}</b-badge></p></b-col>
                      </b-row>
                    </b-col>
                    <b-col md="6">
                      <b-row>
                        <b-col md="4"><label class="labels">Order Date</label></b-col>
                        <b-col md="8"><p>{{ model.orderDate !== null ? getDate(model.orderDate) : '-' }}</p></b-col>
                      </b-row>
                      <b-row v-if="model.statusValue !== ''">
                        <b-col md="4"><label class="labels">{{model.statusText}}</label></b-col>
                        <b-col md="8">
                          <p>{{ model.statusValue }}</p>
                        </b-col>
                      </b-row>
                      <b-row v-if="model.statusTime !== ''">
                        <b-col md="4">
                          <label class="labels">{{model.statusTextTime}}</label>
                        </b-col>
                        <b-col md="8">
                          <p>{{ model.statusTime }}</p>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="4"><label class="labels">Note</label></b-col>
                        <b-col md="8"><p>{{ model.note !== '' ? model.note : '-' }}</p></b-col>
                      </b-row>
                      <b-row>
                        <b-col md="4"><label class="labels">Delivery Date</label></b-col>
                        <b-col md="8"><p>{{ model.deliveryDate !== '' ? getDate(model.deliveryDate) : '-' }}</p></b-col>
                      </b-row>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <h5 class="mb-3 mt-3">Items</h5>
                    </b-col>
                    <b-col md="12">
                      <div class="table-responsive">
                        <table class="table table-hovered table-striped">
                          <thead>
                            <tr>
                              <th scope="col" width="100">No</th>
                              <th >Item ID</th>
                              <th >Name</th>
                              <th class="text-center">Label Unit</th>
                              <th class="text-center">Quantity</th>
                              <th >Unit Price</th>
                              <th >Sub Total</th>
                            </tr>
                          </thead>
                          <tbody v-if="itemList.length > 0">
                            <tr v-for="(item, index) in itemList" :key="item.uuid">
                              <td >{{index+1}}</td>
                              <td >{{item.item.itemId}}</td>
                              <td >{{item.item.name}}</td>
                              <td class="text-center">{{item.item.label}}</td>
                              <td class="text-center">{{item.qtyUsed}}</td>
                              <td >{{ dataAccount.account.currency }} {{formatPrice(item.item.price)}}</td>
                              <td >{{ dataAccount.account.currency }} {{formatPrice(item.balance)}}</td>
                            </tr>
                          </tbody>
                          <tbody v-else>
                            <tr>
                              <td colspan="9" class="text-center" >there's no data</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </b-col>
                    <!--<b-col md="10 mt-2">
                      <p class="float-right">Sub Total: </p>
                    </b-col>
                    <b-col md="2 mt-2">
                      <p class="float-right">{{this.currency === 'Rp' ? 'Rp' : 'RM'}} {{totalPrice}}</p>
                    </b-col>
                    <b-col md="12">
                      <hr width="25%" class="float-right" style="margin-top:-10px!important;">
                    </b-col>-->
                    <b-col md="10 mt-1">
                      <p class="float-right" style="font-size:18px!important;"><b>Total Price: </b></p>
                    </b-col>
                    <b-col md="2 mt-1">
                      <p class="float-right" style="font-size:18px!important;"><b>{{ dataAccount.account.currency }} {{formatPrice(totalPrice)}}</b></p>
                    </b-col>
                    <b-col md="12">
                      <hr width="28%" class="float-right" style="margin-top:-10px!important;">
                    </b-col>
                    <!--<b-col md="12 mb-4 mt-0 pt-2" class="border-radius float-right text-right bg-total" style="max-height:70px">
                      <h5><strong>Total Price : {{this.currency === 'Rp' ? 'Rp' : 'RM'}} {{totalPrice.toFixed(2)}}</strong></h5>
                    </b-col>-->
                </b-row>
                <b-row>
                  <b-col md="12">
                    <h5 class="mt-3 mb-3">Photo</h5>
                  </b-col>
                  <b-col md="12 mt-1 mb-3">
                    <b-row v-if="model.photo === null || model.photo === 'null' || model.photo === ''">
                      <b-col md="3">
                        <p class="text-secondary text-center border border-radius p-5"><i>No Photo Submitted</i></p>
                      </b-col>
                    </b-row>
                    <viewer v-else>
                      <b-row>
                        <b-col md="3 mb-2">
                          <b-img :src="model.photo" class="img-responsive" width="275" height="250"/>
                        </b-col>
                      </b-row>
                    </viewer>
                    <div class="bg-image" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <h5 class="mb-3 mt-2">Sales Order History</h5>
                  </b-col>
                  <b-col md="12">
                    <div class="table-responsive">
                      <table class="table table-hovered table-striped">
                        <thead>
                          <tr>
                            <th scope="col" width="100">Status</th>
                            <th scope="col" width="250">Changed By</th>
                            <th scope="col">Note</th>
                            <th scope="col" width="200">Time</th>
                          </tr>
                        </thead>
                        <tbody v-if="salesOrderHistory.length > 0">
                          <tr v-for="salesOrder in salesOrderHistory" :key="salesOrder.uuid">
                            <td><b-badge :variant="getStatusColor(salesOrder.status)">{{salesOrder.status}}</b-badge></td>
                            <td>{{salesOrder.changedBy}}</td>
                            <td>{{salesOrder.note !== null && salesOrder.note !== '' && salesOrder.note !== 'null' ? salesOrder.note : '-'}}</td>
                            <td>{{getDateTime(salesOrder.createdAt)}}</td>
                            <!--<td>{{model.statusTime !== null ? getDateTime(model.statusTime) : '-'}}</td>-->
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="9" class="text-center">there's no data</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-col>
                </b-row>
            </b-form>
            <b-modal id="bv-modal-example" hide-footer>
              <template v-slot:modal-title>
                  <h5 class="text-transform">{{type}} Sales Order</h5>
              </template>
              <form v-on:submit.prevent="doChangeStatus(type)">
                  <div class="d-block">
                    <!--<label for=""><strong>Type</strong></label>
                    <b-form-input v-model="formData.type" disabled placeholder="Enter type"></b-form-input>-->
                    <label for="" class="mt-2"><strong>Note</strong></label>
                    <b-form-textarea rows="3" v-model="formData.note" placeholder="Enter note"></b-form-textarea>
                  </div>
                  <b-button class="mt-4" @click="$bvModal.hide('bv-modal-example')"><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button>
                  <b-button variant="primary" type="submit" class="mt-4 float-right"> <font-awesome-icon icon="save"></font-awesome-icon> Submit</b-button>
              </form>
            </b-modal>
            <b-modal id="bv-modal-sales" hide-footer>
              <template v-slot:modal-title>
                  <h5 class="text-transform">{{type}} Sales Order</h5>
              </template>
              <form v-on:submit.prevent="doDeliverySales(type)">
                  <template>
                    <div class="d-block">
                      <label for=""><strong>Delivery Date </strong></label>
                      <b-form-datepicker v-model="formData.deliveryDate" placeholder="Enter Delivery Date"></b-form-datepicker>
                      <label for="" class="mt-3"><strong>Note</strong></label>
                      <b-form-textarea rows="3" v-model="formData.note" placeholder="Enter Note"></b-form-textarea>
                    </div>
                  </template>
                  <b-button class="mt-4" @click="$bvModal.hide('bv-modal-sales')"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
                  <b-button variant="primary" type="submit" class="mt-4 float-right"><font-awesome-icon icon="save"></font-awesome-icon> Submit</b-button>
              </form>
            </b-modal>
            <b-button class="mt-3" :to="'/sales/sales-order'"  variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
            <!--<b-button v-if="model.status === 'Requested'" class="mt-3 float-right" :to="'/sales/sales-order/' + $route.params.uuid + '/edit'" variant="warning"><font-awesome-icon icon="pencil-alt"></font-awesome-icon> Edit</b-button>-->
        </b-card>
    </div>
</template>

<script>
    import 'viewerjs/dist/viewer.css'
    import Viewer from 'v-viewer'
    import Vue from 'vue'
    Vue.use(Viewer)

    export default {
        name: 'sales-order-details',
        data () {
          return {
            isLoading: false,
            dataAccount: this.$store.getters['account/accountData'],
            apiUrl: {
              salesOrder: window.AppConfig.apiUrl + 'sales-order',
              exportSalesOrderDetail: window.AppConfig.apiUrl + 'export-sales-order-detail',
              salesOrderHistoryStatus: window.AppConfig.apiUrl + 'sales-order-history-status'
            },
            account: null,
            model: {
              orderId: null,
              orderDate: null,
              company: null,
              branch: null,
              customer: null,
              requestedBy: null,
              statusText: '',
              statusValue: '',
              statusTime: '',
              statusTextTime: '',
              salesOrderItem: null,
              status: null,
              photo: null,
              note: null,
              deliveryDate: ''
            },
            itemList: [],
            // salesOrderList: [],
            salesOrderHistory: [],
            formData: {
              note: null,
              deliveryDate: '',
              type: 'sales-order'
            },
            totalPrice: 0,
            currency: '',
            balance: 0,
            pricePerUnit: 0
          }
        },
        mounted () {
          this.getDetail()
          this.getHistoryStatus()
        },
        methods: {
          getDetail () {
            this.isLoading = true
            this.$http.get(this.apiUrl.salesOrder + '/' + this.$route.params.uuid).then(response => {
              this.model.orderId = response.data.orderId !== null ? response.data.orderId : '-'
              this.model.orderDate = response.data.orderDate !== null ? response.data.orderDate : '-'
              this.model.company = response.data.company !== null ? response.data.company.name : '-'
              this.model.branch = response.data.branch !== null ? response.data.branch.name : '-'
              this.model.requestedBy = response.data.requestedBy !== null ? response.data.requestedBy.name : '-'
              this.model.status = response.data.status !== null ? response.data.status : '-'
              this.model.deliveryDate = response.data.deliveryDate !== '' ? response.data.deliveryDate : '-'
              this.model.customer = response.data.customer !== null ? response.data.customer.name : '-'
              this.model.note = response.data.note !== null ? response.data.note : '-'
              this.account = response.data.account !== null ? response.data.account.uuid : '-'
              this.model.photo = response.data.path
              // this.salesOrderList = []
              // if (response.data.salesOrderHistory !== null) {
              //   response.data.salesOrderHistory.forEach(data => {
              //     this.salesOrderList.push(data)
              //   })
              // }
              this.itemList = []
              this.totalPrice = 0
              if (response.data.salesOrderItem !== null) {
                response.data.salesOrderItem.forEach(data => {
                  this.totalPrice += Math.round(data.balance)
                  this.itemList.push(data)
                  this.currency = data.item.itemCategory.currency
                  // this.balance = data.balance
                  // this.pricePerUnit = data.item.price
                })
              }
              if (response.data.rejectedBy !== null) {
                this.model.statusText = 'Rejected By'
                this.model.statusTextTime = 'Rejected Time'
                this.model.statusValue = response.data.rejectedBy
                this.model.statusTime = response.data.rejectedTime !== null ? this.$moment(response.data.rejectedTime).format('YYYY-MM-DD hh:mm A') : '-'
              }
              if (response.data.approvedBy !== null) {
                this.model.statusText = 'Approved By'
                this.model.statusTextTime = 'Approved Time'
                this.model.statusValue = response.data.approvedBy
                this.model.statusTime = response.data.approvedTime !== null ? this.$moment(response.data.approvedTime).format('YYYY-MM-DD hh:mm A') : '-'
              }
            })
          },
          getHistoryStatus () {
            this.isLoading = true
            this.$http.get(this.apiUrl.salesOrderHistoryStatus + '?sales_order_uuid=' + this.$route.params.uuid + '&ascending=1').then(response => {
              this.salesOrderHistory = []
              response.data._embedded.sales_order_history_status.forEach(data => {
                this.salesOrderHistory.push(data)
              })
              this.isLoading = false
            })
          },
          doExportToPDF () {
            let url = this.apiUrl.exportSalesOrderDetail + '?token=' + this.$store.getters['account/tokens'].access_token + '&sales_order_uuid=' + this.$route.params.uuid

            window.open(url)
          },
          showModalSales (type) {
            this.formData.deliveryDate = ''
            this.formData.note = null
            this.type = type
            this.$bvModal.show('bv-modal-sales')
          },
          doDeliverySales (type) {
            this.isLoading = true
            let model = {
              uuid: this.$route.params.uuid,
              action: type,
              type: this.formData.type,
              deliveryDate: this.formData.deliveryDate,
              note: this.formData.note
            }
            this.$http.post(window.AppConfig.apiUrl + 'sales-action', model)
            .then(() => {
              this.isLoading = false
              this.formData.deliveryDate = ''
              this.formData.note = null
              this.$bvModal.hide('bv-modal-sales')
              this.getDetail()
              this.getHistoryStatus()
              this.$store.dispatch('notification/success', 'Sales Order has been approved')
            })
            .catch(error => {
              this.isLoading = false
              this.$store.dispatch('notification/error', error)
            });
          },
          formatPrice(value) {
            let val = (value/1).toFixed(2).replace(',', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          },
          showModal (type) {
            this.formData.note = null
            // this.formData.type = this.formData.type
            this.type = type
            this.$bvModal.show('bv-modal-example')
          },
          doChangeStatus (type) {
            this.isLoading = true
            this.$http.post(window.AppConfig.apiUrl + 'sales-action', {
              uuid: this.$route.params.uuid,
              action: type,
              // type: this.formData.type,
              note: this.formData.note
            })
            .then(() => {
              this.isLoading = false
              this.formData.note = null
              this.getDetail()
              this.getHistoryStatus()
              this.$bvModal.hide('bv-modal-example')
              this.$store.dispatch('notification/success', 'Sales Order has been rejected')
            })
            .catch(error => {
              this.isLoading = false
              this.$store.dispatch('notification/error', error)
            });
          },
          getDateTime (value) {
            if (value !== null) {
              return this.$moment(value).format('YYYY-MM-DD HH:mm A')
            } else {
              return '-'
            }
          },
          getDate (value) {
            if (value !== null) {
              return this.$moment(value).format('YYYY-MM-DD')
            } else {
              return '-'
            }
          },
          goBack () {
            window.goBack(this)
          },
          getStatusColor (val) {
            switch (val) {
              case 'Requested':
                return 'info'
                // eslint-disable-next-line no-unreachable
                break
              case 'Approved':
                return 'success'
                // eslint-disable-next-line no-unreachable
                break
              case 'Rejected':
                return 'danger'
                // eslint-disable-next-line no-unreachable
                break
            }
          },
          getStatusName (val) {
            if (val) {
              return "Headquarters"
            } else {
              return "Branch"
            }
          }
      }
    }
</script>